module.exports = __webpack_public_path__ + "img/yhubFlow.e0ad27b9.jpg";